module.exports = __webpack_public_path__ + "static/img/common.5f45052.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/upload/common.png
// module id = lVii
// module chunks = 1